import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";

export const TechnicalMetadataForm = styled.form`
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    max-width: 100% !important;
    width: 100%;
    margin: 1.25em 0 0 0 !important;
    margin-bottom: 32px !important;
`;

export const FormLabel = styled.label`
    font-size: var(--size-header);
    margin: 16px 0 !important;
`;

export const FileField = styled.div`
    height: 30em;
    background-color: var(--color-primary-light);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 12px 12px 12px 0;
    border: 4px dotted rgba(var(--color-primary-desat-rgb),.1);

    label
    {
        color: var(--color-dark-green);
        font-size: var(--size-header);
        font-weight: 500;
    }

    input
    {
        display: none;
        visibility: hidden;
    }
`;

export const FileFieldAppendix = styled.div`
    background-color: var(--color-primary-light);
    border: 4px dotted rgba(var(--color-primary-desat-rgb),.1);
    border-top: 0;
    border-radius:0 0 12px 12px;
    display: flex;
    flex-direction: row;
    gap: .8rem;
    align-items: center;
    padding: 12px 16px;
    align-self: flex-start;

    font-size: var(--size-main);
    color: var(--color-dark-green);

    label
    {
        font-weight: 500;
    }

`;

export const LabelIcon = styled(FontAwesomeIcon)`
    font-size: calc((3/4) * var(--size-title));
    margin-bottom: 16px;
`;
